// Vuetify Theme Configuration with Multiple Color Schemes
// Add this to your main.js or create as plugins/vuetify.js

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Default theme (your current green theme)
const defaultTheme = {
  dark: false,
  colors: {
    primary: '#4A8B7F',
    secondary: '#6B9E95',
    accent: '#82B1A8',
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
    background: '#F5F5F5',
    surface: '#FFFFFF'
  }
}

// Nordic (soft teal with clean readability)
const nordicTheme = {
  dark: false,
  colors: {
    primary: '#6BA4A0',
    secondary: '#88B9B5',
    accent: '#A3CEC9',
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
    background: '#F2F5F4',
    surface: '#FFFFFF',
    'on-background': '#2E3440',
    'on-surface': '#2E3440'
  }
}

// Twitter (Classic Blue)
const twitterTheme = {
  dark: false,
  colors: {
    primary: '#1DA1F2',
    secondary: '#14171A',
    accent: '#657786',
    success: '#17BF63',
    warning: '#FFAD1F',
    error: '#E0245E',
    info: '#1DA1F2',
    background: '#E6ECF0',
    surface: '#FFFFFF'
  }
}

// Facebook Blue
const facebookTheme = {
  dark: false,
  colors: {
    primary: '#1877F2',
    secondary: '#42B72A',
    accent: '#F0F2F5',
    success: '#42B72A',
    warning: '#F7B928',
    error: '#FA3E3E',
    info: '#1877F2',
    background: '#F0F2F5',
    surface: '#FFFFFF'
  }
}

// Purple/Violet
const purpleTheme = {
  dark: false,
  colors: {
    primary: '#7C4DFF',
    secondary: '#B388FF',
    accent: '#EA80FC',
    success: '#69F0AE',
    warning: '#FFD740',
    error: '#FF5252',
    info: '#40C4FF',
    background: '#F3E5F5',
    surface: '#FFFFFF'
  }
}

// Warm Orange
const warmTheme = {
  dark: false,
  colors: {
    primary: '#FF7043',
    secondary: '#FFAB91',
    accent: '#FFE0B2',
    success: '#81C784',
    warning: '#FFB74D',
    error: '#E57373',
    info: '#4FC3F7',
    background: '#FFF3E0',
    surface: '#FFFFFF'
  }
}

// Dark Mode
const darkTheme = {
  dark: true,
  colors: {
    primary: '#4A8B7F',
    secondary: '#6B9E95',
    accent: '#82B1A8',
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
    background: '#121212',
    surface: '#1E1E1E'
  }
}

// Twitter Dark (Dim)
const twitterDarkTheme = {
  dark: true,
  colors: {
    primary: '#1DA1F2',
    secondary: '#8899A6',
    accent: '#657786',
    success: '#17BF63',
    warning: '#FFAD1F',
    error: '#E0245E',
    info: '#1DA1F2',
    background: '#15202B',
    surface: '#192734'
  }
}

// High Contrast (Accessibility)
const highContrastTheme = {
  dark: false,
  colors: {
    primary: '#000000',
    secondary: '#000000',
    accent: '#FFFF00',
    success: '#00AA00',
    warning: '#FFAA00',
    error: '#FF0000',
    info: '#0000FF',
    background: '#FFFFFF',
    surface: '#FFFFFF'
  }
}

// Export all themes
export const themes = {
  default: defaultTheme,
  nordic: nordicTheme,
  twitter: twitterTheme,
  facebook: facebookTheme,
  purple: purpleTheme,
  warm: warmTheme,
  dark: darkTheme,
  twitterDark: twitterDarkTheme,
  highContrast: highContrastTheme
}

// Theme names for UI display
export const themeOptions = [
  { key: 'default', name: 'Gørlev Station (Standard)', icon: 'mdi-leaf' },
  { key: 'nordic', name: 'Nordisk', icon: 'mdi-snowflake' },
  { key: 'twitter', name: 'Twitter Klassisk', icon: 'mdi-twitter' },
  { key: 'facebook', name: 'Facebook Blå', icon: 'mdi-facebook' },
  { key: 'purple', name: 'Lilla', icon: 'mdi-palette' },
  { key: 'warm', name: 'Varm Orange', icon: 'mdi-white-balance-sunny' },
  { key: 'dark', name: 'Mørk', icon: 'mdi-weather-night' },
  { key: 'twitterDark', name: 'Twitter Mørk', icon: 'mdi-twitter' },
  { key: 'highContrast', name: 'Høj Kontrast', icon: 'mdi-contrast-circle' }
]

// Create Vuetify instance
export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'default',
    themes: {
      default: defaultTheme,
      nordic: nordicTheme,
      twitter: twitterTheme,
      facebook: facebookTheme,
      purple: purpleTheme,
      warm: warmTheme,
      dark: darkTheme,
      twitterDark: twitterDarkTheme,
      highContrast: highContrastTheme
    }
  }
})

export default vuetify